module.exports = __webpack_public_path__ + "static/media/dashboard-highlight-icon.1723bf67.svg";